import { type Program } from '../../vendors/vendorList.types'

export enum AICategory {
  unaware = 'Nekvalifikovan - Potrebno je napredovanje',
  aware = 'Kvalifikovan - Istraživački nivo',
  ready = 'Kvalifikovan - Srednji nivo',
  competent = 'Kvalifikovan - Napredni nivo',
}

export interface Level {
  id?: number
  slug: string
  name: string
  value: number
  max: number
}

interface Result {
  score: number
  level: Level
  completedAt: string
}

export interface QuestionAnswer {
  id: string
  answer: string
  skip?: number
  selected?: boolean
  points?: number
}

export interface Question {
  id: string
  question: string
  description: string
  type: 'single' | 'multiple'
  group: {
    id: string
    name: string
  }
  answers: QuestionAnswer[]
}

export interface Questionnaire {
  id: string
  slug: string
  version?: number
  versionId: string
  name: string
  description: string
  result?: Result
  questions?: Question[]
}

interface Group {
  id: string
  name: string
  points: number
  maxPoints: number
  questions: Question[]
}

export interface QuestionnaireResults {
  score: number
  questionnaire: Questionnaire
  level: Level
  completedAt: string
  groups: Group[]
  programs?: Program[]
}

export interface QuestionnaireResultsPayload {
  companyId: string
  questionnaireId: string
}

export interface PostQuestionnaireResponsePayload {
  companyId: string
  questionnaireId: string
  questionnaireVersionId: string
  response: {
    startTime: string
    answers: Array<{ questionId: string; answerIds: string[] }>
  }
}
